import React from 'react';
import {Link} from "react-router-dom";

const Interested = ({handleMenuClick}) => {
  return (
    <>
    <section id="contactme">
      <h2>
        Interested in doing a project together?
      </h2>
      
      <div>
        
      </div>
      
      <Link to="/contact">
        <button id="contact" className="btn-snormal" onClick={handleMenuClick}>
          CONTACT ME
        </button>
      </Link>
    </section>
    </>
  );
}

export default Interested;